/* Тексты страницы «Дистрибуция» для авиакомпаний и GSA. Туркменский показывает английскую версию, как и остальные информационные страницы. */

const en = {
  title: "Airline Ticket and Charter Flight Distribution",
  subtitle: "Your Flights — New Markets and More Customers",
  intro: [
    "FlyAshgabat invites airlines, general sales agents (GSAs), official airline representatives, travel agencies, and companies holding their own seat allocations, special fares, and charter programs to partner with us.",
    "We offer a modern platform for online sales and promotion of your flight inventory, helping you expand your market reach, attract new customers, and increase sales volumes.",
  ],
  offersTitle: "What Can You List on Our Platform?",
  offers: [
    "Scheduled flights with special fares",
    "Charter and additional flights",
    "Seat blocks and flight allotments",
    "Group and corporate fares",
    "Other flight offers available for distribution through partner channels",
  ],
  benefitsTitle: "Benefits of Partnering with FlyAshgabat",
  benefits: [
    {
      title: "Online Sales",
      text: "List your flights and fares on the FlyAshgabat platform, enabling customers to search, book, and obtain tickets in accordance with agreed terms.",
    },
    {
      title: "Expanded Sales Reach",
      text: "Reach customers in Ashgabat, across Turkmenistan, and in Russia, where many of our fellow Turkmen citizens actively purchase airline tickets online. Looking ahead, we aim to enter new markets and further expand our regional presence.",
    },
    {
      title: "Flight Promotion",
      text: "Run marketing campaigns and promote new routes, charter programs, and special offers through FlyAshgabat’s marketing channels.",
    },
    {
      title: "Access to Our B2B Channel",
      text: "Distribute your fares through our B2B platform for travel agencies and corporate clients, opening up additional sales channels.",
    },
    {
      title: "Flexible Integration Options",
      text: "We support different ways to connect, from manually adding flights, fares, and seat allotments to full API integration, including NDC technology with the option to book ancillary services (baggage, seat selection, and more).",
    },
    {
      title: "Tailored Commercial Terms",
      text: "Flexible agreements on fares, commissions, settlement arrangements, and other partnership terms to suit your business needs.",
    },
  ],
  stepsTitle: "How to Become a Partner",
  steps: [
    {
      title: "1. Contact Us",
      text: "Tell us about your company, the airlines you represent, and the flight offers you can provide.",
    },
    {
      title: "2. Agree on Terms",
      text: "We will discuss commercial terms, integration methods, and the booking and ticket issuance process.",
    },
    {
      title: "3. Connect and Start Selling",
      text: "Once terms are agreed and setup is complete, your offers will become available for sale through the relevant FlyAshgabat channels.",
    },
  ],
  ctaTitle: "Grow Your Sales with FlyAshgabat",
  ctaText: "Turn your fares, seat allotments, and charter programs into new business opportunities.",
  ctaButton: "Become a FlyAshgabat Partner",
};

const ru = {
  title: "Дистрибуция авиабилетов и чартерных рейсов",
  subtitle: "Ваши рейсы — новые рынки и больше клиентов",
  intro: [
    "FlyAshgabat приглашает к партнёрству авиакомпании, генеральных агентов по продажам (GSA), официальных представителей авиакомпаний, туристические агентства и компании, располагающие собственными блоками мест, специальными тарифами и чартерными программами.",
    "Мы предлагаем современную платформу для онлайн-продаж и продвижения ваших рейсов, которая помогает расширить присутствие на рынке, привлечь новых клиентов и увеличить объёмы продаж.",
  ],
  offersTitle: "Что можно разместить на нашей платформе?",
  offers: [
    "Регулярные рейсы со специальными тарифами",
    "Чартерные и дополнительные рейсы",
    "Блоки мест и квоты на рейсах",
    "Групповые и корпоративные тарифы",
    "Другие предложения по рейсам, доступные для продажи через партнёрские каналы",
  ],
  benefitsTitle: "Преимущества партнёрства с FlyAshgabat",
  benefits: [
    {
      title: "Онлайн-продажи",
      text: "Размещайте рейсы и тарифы на платформе FlyAshgabat: клиенты смогут находить, бронировать и получать билеты на согласованных условиях.",
    },
    {
      title: "Расширение географии продаж",
      text: "Выходите на клиентов в Ашхабаде, по всему Туркменистану и в России, где многие наши соотечественники активно покупают авиабилеты онлайн. В дальнейшем мы планируем выходить на новые рынки и укреплять присутствие в регионе.",
    },
    {
      title: "Продвижение рейсов",
      text: "Проводите маркетинговые кампании и продвигайте новые маршруты, чартерные программы и специальные предложения через маркетинговые каналы FlyAshgabat.",
    },
    {
      title: "Доступ к нашему B2B-каналу",
      text: "Продавайте свои тарифы через нашу B2B-платформу для туристических агентств и корпоративных клиентов — это дополнительные каналы продаж.",
    },
    {
      title: "Гибкие варианты интеграции",
      text: "Мы поддерживаем разные способы подключения: от ручного добавления рейсов, тарифов и блоков мест до полной API-интеграции, включая технологию NDC с возможностью бронирования дополнительных услуг (багаж, выбор места и другие).",
    },
    {
      title: "Индивидуальные коммерческие условия",
      text: "Гибкие договорённости по тарифам, комиссиям, порядку расчётов и другим условиям партнёрства с учётом потребностей вашего бизнеса.",
    },
  ],
  stepsTitle: "Как стать партнёром",
  steps: [
    {
      title: "1. Свяжитесь с нами",
      text: "Расскажите о вашей компании, авиакомпаниях, которые вы представляете, и предложениях по рейсам, которые можете предоставить.",
    },
    {
      title: "2. Согласуйте условия",
      text: "Мы обсудим коммерческие условия, способы интеграции и порядок бронирования и выписки билетов.",
    },
    {
      title: "3. Подключитесь и начните продавать",
      text: "После согласования условий и завершения настройки ваши предложения станут доступны для продажи через соответствующие каналы FlyAshgabat.",
    },
  ],
  ctaTitle: "Увеличивайте продажи вместе с FlyAshgabat",
  ctaText: "Превратите свои тарифы, блоки мест и чартерные программы в новые возможности для бизнеса.",
  ctaButton: "Стать партнёром FlyAshgabat",
};

const distributionContent = { en, ru };

export default distributionContent;
